import { SkeletonBox, SkeletonText, SkeletonCircle } from '../primitives';
import '../primitives/Skeletons.css';

const DetailRow = () => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingBlock: 'var(--space-sm)',
      borderBottom: '1px solid var(--color-border-subtle)',
    }}
  >
    <SkeletonText widths={['96px']} lineHeight="14px" />
    <SkeletonText widths={['120px']} lineHeight="14px" />
  </div>
);

const BillingCompleteSkeleton = () => (
  <div
    aria-hidden="true"
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 'var(--space-lg)',
      padding: 'clamp(2rem, 5vw, 3rem) var(--space-xl)',
      maxWidth: '560px',
      margin: '0 auto',
    }}
  >
    {/* Success ring + check stand-in */}
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 'var(--space-sm)' }}>
      <SkeletonCircle size={88} variant="pulse" />
    </div>

    {/* Heading */}
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem', alignItems: 'center' }}>
      <SkeletonText widths={['min(360px, 80vw)']} lineHeight="32px" />
      <SkeletonText widths={['min(280px, 70vw)']} lineHeight="14px" />
    </div>

    {/* Receipt card */}
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 'var(--space-sm)',
        padding: 'var(--space-lg)',
        borderRadius: 'var(--radius-lg)',
        border: '1px solid var(--color-border)',
        background: 'var(--color-surface)',
      }}
    >
      <SkeletonText widths={['120px']} lineHeight="16px" />
      <DetailRow />
      <DetailRow />
      <DetailRow />
      <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: 'var(--space-sm)' }}>
        <SkeletonText widths={['72px']} lineHeight="18px" />
        <SkeletonText widths={['96px']} lineHeight="20px" />
      </div>
    </div>

    {/* Action buttons */}
    <div style={{ display: 'flex', gap: 'var(--space-md)', flexWrap: 'wrap', justifyContent: 'center' }}>
      <SkeletonBox width={160} height={44} borderRadius="999px" />
      <SkeletonBox width={140} height={44} borderRadius="999px" />
    </div>
  </div>
);

export default BillingCompleteSkeleton;
